import { withEventScope } from '@repo/event-processor';
import { Spacer } from '@repo/ui/components/Spacer';
import { H3 } from '@repo/ui/components/Typography';

import ChangeSubscriptionActions from '../../ActionButtons/ChangeSubscriptionActions/ChangeSubscriptionActions';
import PaymentInfo from '../../PaymentInfo/PaymentInfo';
import PlanMembersSelector from '../../PlanMembersSelector/PlanMembersSelector';
import {
  RightPanelBlock,
  RightPanelFormBlock,
  RightPanelBottomBlock,
  ActionButtonsWrapper,
  RightPanelWrapper,
} from '../../styles';
import usePlanPurchaseDetails from '../../SubscriptionModal/hooks/usePlanPurchaseDetails';

import { TeamSizeDetailsProps } from './types';

const TeamSizeDetails: React.FC<TeamSizeDetailsProps> = ({
  currentSubscription,
  subscriptionChangePreviewData,
}) => {
  const { isUpgrade } = usePlanPurchaseDetails({
    currentSubscription,
    subscriptionChangePreviewData,
  });

  return (
    <RightPanelWrapper>
      <RightPanelBlock>
        <RightPanelFormBlock>
          <H3>Change team size</H3>
          <PlanMembersSelector />
        </RightPanelFormBlock>
        <Spacer height="16px" />
        <RightPanelBottomBlock>
          <PaymentInfo
            currentSubscription={currentSubscription}
            subscriptionChangePreviewData={subscriptionChangePreviewData}
          />
        </RightPanelBottomBlock>
        <Spacer height="24px" />
      </RightPanelBlock>
      {currentSubscription && (
        <ActionButtonsWrapper>
          <ChangeSubscriptionActions
            currentSubscription={currentSubscription}
            isUpgrade={isUpgrade}
            subscriptionChangePreviewData={subscriptionChangePreviewData}
          />
        </ActionButtonsWrapper>
      )}
    </RightPanelWrapper>
  );
};

export default withEventScope(TeamSizeDetails, { module: 'teamSizeDetails' });
